<div
  class="container-fluid d-flex text-light flex-nowrap flex-column justify-content-center align-items-center c-height 444">
  <div class="custom-max-width">
    <div class="column slideInUp">
      <h1 class="display-2 font-2_2rem mb-3 text-center" style="font-weight: 600">
        {{ "Knowledge gate" | translator }}
      </h1>
      <p class="text-center">
        {{ "To know" | translator }} | {{ "Training" | translator }} |
        {{ "Development" | translator }}
      </p>
    </div>
    <div class="p-inputgroup my-3">
      <span class="p-input-icon-right w-100">
        <i class="pi pi-search"></i>
        <input type="text" class="p-inputtext-lg sstarabic w-100 radius-8 slideInUp" pInputText
          placeholder="{{ 'Discus' | translator }}" (keydown.enter)="navigateToSearch($event)" [(ngModel)]="searchText"
          [disabled]="isLoggedIn && !hasPermission('CONTENT','r')" />
      </span>
    </div>
    <div class="d-flex justify-content-between w-100">
      <span class="btn-flex mb-2">
        <span *ngIf="isLoggedIn" class="btn-css mx-2 font-0_8rem slideInUp">
          {{ "Brother searches" | translator }}
        </span>
        <span class="icon-box">
          <i class="fa-solid fa-angle-down font-500 font-15"></i>
        </span>
      </span>
      <p-button [routerLink]="isLoggedIn && !hasPermission('CONTENT','r') ? '' : '/advance-search'"
        styleClass="border-0 bg-transparent" label="{{ 'advanced search' | translator }}" icon="pi pi-angle-right"
        [disabled]="isLoggedIn && !hasPermission('CONTENT','r')"></p-button>
    </div>
    <div *ngIf="isLoggedIn" class="d-flex align-items-center w-100 overflow-auto gap-2 m-bottom-4 pb-3">
      <p-chip class="pointer slideInUp" *ngFor="let item of recentsearches" [label]="item._id"
        (click)="!hasPermission('CONTENT','r') ? null : searchItem(item._id)"
        styleClass="text-dark px-3 white-space-nowrap text-nowrap"></p-chip>
    </div>
  </div>

  <div *ngIf="serviceCounts?.length > 0 && showServiceCount" class="d-flex mob-overflow">
    <div role="button" (click)="(isLoggedIn && !hasPermission('CONTENT','r')) ? null : openLicenseModal(item)"
      *ngFor="let item of serviceCounts" class="bg-color custom-box text-dark slideInUp">
      <h2 class="m-0 font-bold">{{ item?.count }}</h2>
      <p class="m-0">{{ item?.type?.arabic }}</p>
    </div>
  </div>

  <!-- Directory -->
  <!-- <div class="z-index-1 directory-pos-v4">
    <h1 class="directory-v4">شركاؤنا</h1>
    <div class="d-flex flex-wrap">
      <span class="directory-text"
        >الرئيسية<i
          class="fa-solid fa-chevron-left directory-icone my-2 mx-3"
        ></i
      ></span>
      <span class="directory-text"
        >الاتفاقيات و الشراكات<i
          class="fa-solid fa-chevron-left directory-icone my-2 mx-3"
        ></i
      ></span>
      <span class="directory-text-active">شركاؤنا</span>
    </div>
  </div> -->
  <!-- Directory -->
</div>

<p-dialog [blockScroll]="true" [draggable]="false" [(visible)]="visibleModal"
  header="{{ currentFieldType?.type?.arabic }}" [style]="{ width: '95vw', maxWidth: '800px' }">
  <ng-template pTemplate="body">
    <div role="button" (click)="navigateToResult(ou)"
      class="d-flex align-items-center justify-content-between px-5 py-2 border rounded mb-2"
      *ngFor="let ou of filteredOus">
      <div class="d-flex gap-1 align-items-center" style="width: fit-content">
        <div class="v4-icon-bg">
          <img src="{{ staticURL + ou.image }}" style="object-fit: contain; width: 100%; height: 100%"
            *ngIf="checkisImg(ou?.image); else elseBlock" alt="" />
        </div>
        <ng-template #elseBlock>
          <i class="pi pi-{{ ou?.image }}" style="font-size: 1rem"></i>
        </ng-template>
        <span style="font-size: 16px; color: white">{{ ou.name }}</span>
      </div>
      <span style="font-size: 14px; color: white">{{ getCount(ou) }}</span>
    </div>
  </ng-template>
</p-dialog>